import { gpHome } from '../../app';
import { AnalysisProject } from '../../services/analysis-contract';
import analysisListItemTemplate from './analysis-list-item.html';

class AnalysisListItemComponent {

    project!: AnalysisProject;
    onClick!: () => void;

    getStatusLabel(): string {
        if (!this.project) return 'Pending';

        // In-session task state takes priority (active processing)
        if (this.project.tasks && this.project.tasks.length > 0) {
            const allComplete = this.project.tasks.every(t => t.status === 'complete');
            if (allComplete) return 'Complete';

            const running = this.project.tasks.find(t => t.status === 'running');
            if (running) return running.name;

            const hasError = this.project.tasks.some(t => t.status === 'error');
            if (hasError) return 'Error';
        }

        // Fall back to persisted status from project.json
        switch (this.project.status) {
            case 'uploaded': return 'Uploaded';
            case 'imported': return 'Imported';
            case 'importing': return 'Converting...';
            case 'error': return 'Error';
            default: return 'Pending';
        }
    }

    getStatusClass(): string {
        if (!this.project) return 'status-pending';

        if (this.project.tasks && this.project.tasks.length > 0) {
            const allComplete = this.project.tasks.every(t => t.status === 'complete');
            if (allComplete) return 'status-complete';

            const hasError = this.project.tasks.some(t => t.status === 'error');
            if (hasError) return 'status-error';

            const hasRunning = this.project.tasks.some(t => t.status === 'running');
            if (hasRunning) return 'status-running';
        }

        switch (this.project.status) {
            case 'uploaded': return 'status-complete';
            case 'imported': return 'status-complete';
            case 'error': return 'status-error';
            case 'importing': return 'status-running';
            default: return 'status-pending';
        }
    }

    getFileTypeIcon(): string {
        switch (this.project?.fileType) {
            case 'mpp': return 'fa-file-text';
            case 'xer': return 'fa-file-code-o';
            case 'xml': return 'fa-file-code-o';
            case 'csv': return 'fa-file-excel-o';
            default: return 'fa-file-o';
        }
    }

    formatFileSize(): string {
        const bytes = this.project?.fileSizeBytes || 0;
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    formatDate(): string {
        const dateStr = this.project?.lastModifiedUtc;
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    }
}

gpHome.component('gpAnalysisListItem', {
    template: analysisListItemTemplate,
    controller: AnalysisListItemComponent,
    bindings: {
        project: '<',
        onClick: '&',
    },
});
